import { deleteInventoryItemService } from "../infrastructure/services/deleteInventoryItemService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const deleteInventoryItem = {
    async execute(reference: string): Promise<void> {
        await deleteInventoryItemService.execute(await tokenValidation.execute(), reference);
    },
};

